<template>
  <div>
    <v-layout wrap>
      <v-flex  xs12 sm12 md8 lg8>
        <v-btn icon  color="none" :to="{ name : 'storage-products' }">
          <v-icon>arrow_left</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm12 md4 lg4>
        <v-text-field @change="search($event)" label="Szukaj"></v-text-field>
      </v-flex>
    </v-layout>

    <v-data-table :loading="loading" :pagination.sync="pagination" :headers=" headers" :items="productsHistory" class="elevation-10">
      <template v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.product_name }}</td>
        <td>{{ props.item.product_description }}</td>
        <td>{{ getPrettyDecimal(props.item.previous) }}</td>
        <td>{{ getPrettyDecimal(props.item.actualy) }}</td>
        <td>{{ props.item.modified_full_name }}</td>
        <td>{{ props.item.modification_date }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ItemForm from "@/components/storage/ItemForm";
import New from "@/components/storage/New";
import Messenger from "@/plugins/Messenger";
import StringHelper from "../../plugins/StringHelper";

export default {
  name: "Index",
  components: {New, ItemForm},
  data(){
    return{
      dialogNewProduct:false,
      dialog: false,
      updateItem: null,
      loading: true,
      productsHistory : [],
      allproductsHistory : [],
      products : [],
      users : [],
      headers:[
        {
          text: 'ID',
          value: "id",
        },
        {
          text: this.$t('archive.name'),
          value: 'name'
        },
        {
          text: this.$t('department.description'),
          value: 'description'
        },
        {
          text: 'Ilość przed zmianą',
          value: 'previous'
        },
        {
          text: 'Ilość po zmianie',
          value: 'actualy'
        },
        {
          text: 'Modyfikowane przez',
          value: 'modified_by'
        },
        {
          text: 'Data modyfikacji',
          value: 'modification_date'
        },
      ],
      pagination:{
        descending: true,
        page: 1,
        rowsPerPage: 25 // -1 for All",
      }
    }
  },
  methods:{
    getPrettyDecimal(decimal){
      return StringHelper.prettyDecimal(decimal)
    },
    getUser(id){
      let user =  this.users.find(el => el.id == id)
      if(user){
        return user.name +" " + user.surname
      }
      return ""
    },
    getProductData(id){
      let product =  this.products.find(el => el.id == id)
      if(product){
        return { name : product.name, description: product.description }
      }
      return { name : "", description: ""}
    },
    search(text) {
      if (text == "") {
        this.productsHistory = this.allproductsHistory
      }

      text = text.toLowerCase()
      this.productsHistory = this.allproductsHistory.filter(product =>
          product.product_name.toLowerCase().includes(text) || product.product_description.toLowerCase().includes(text)
          || product.modified_full_name.toLowerCase().includes(text) || product.modification_date.includes(text)
      )
    },
    expandProductHistory(ph){
      let productData = this.getProductData(ph.storage_id)
      ph.product_name = productData.name
      ph.product_description = productData.description
      ph.modified_full_name = this.getUser(ph.modified_by)
      return ph
    }
  },
  created() {
    let storage = this.$http.get('/storage')
    let users = this.$http.get('/users')
    let storageHitsory = this.$http.get('/storage/history')

    this.loading = true
    Promise.all([storage,users,storageHitsory]).then(data=>{
      this.products  = data[0].data
      this.users = data[1].data
      this.productsHistory = data[2].data.map(this.expandProductHistory)
      this.allproductsHistory = JSON.parse(JSON.stringify(this.productsHistory))
      this.loading = false
    }).catch(()=>Messenger.emitError("Nie można pobrać historii"))
  }
}
</script>

<style scoped>

</style>